$(document).ready(function () {

    // TTGAT-104
    $('a[href="mailto:jobs@ttg.at"]').click(function(){
        console.log('mailto:jobs@ttg.at');
        gtag('event', 'Klick auf E-Mail Adresse', {
            'event_category': 'Klick',
            'event_label': 'jobs@ttg.at'
        });
    });

});
